import { useTranslation } from 'react-i18next';
import SheetCloseButton from './SheetCloseButton';

export default function SheetHeader({
  title,
  subtitle,
  titleId,
  onClose,
  onBack,
  closeTestId,
  contentClassName = 'mb-5',
  children = null,
}) {
  const { t } = useTranslation();
  const actionProps = onBack
    ? {
        onClick: onBack,
        iconName: 'chevron-left',
        ariaLabel: t('common.back', 'Back'),
        testId: 'sheet-back-button',
      }
    : {
        onClick: onClose,
        testId: closeTestId,
      };

  return (
    <>
      <div
        aria-hidden
        className="mx-auto mb-6 h-1 w-10 rounded-full bg-text-tertiary/40"
      />
      <SheetCloseButton {...actionProps} />

      <div className={`${contentClassName} pr-10`}>
        <h2
          id={titleId}
          className="font-sans text-sheet-title text-text-primary"
        >
          {title}
        </h2>
        {subtitle ? (
          <p className="mt-2 font-sans text-sheet-subtitle text-text-secondary">
            {subtitle}
          </p>
        ) : null}
        {children}
      </div>
    </>
  );
}
